import { InjectionToken } from '@angular/core';
import { AgenteModel } from '../../models/agente.model';

export interface AuthenticationContext {
  agentModel: AgenteModel;
  logout(): void;
}

export const AUTHENTICATION_CONTEXT = new InjectionToken<AuthenticationContext>(
  'AUTHENTICATION_CONTEXT',
);
